/**
 * MaskedValue — a masked secret as the API returns it, `••••` plus the last
 * characters, in mono (style guide §7.2; mission 6 WP03 T023; NFR-006; GEN.3).
 *
 * The value appears as text only: never in a `title`, an `aria-label`, a
 * `data-*` attribute or a tooltip.
 */
import { Mono } from '@/lib/format'

export function MaskedValue({ value }: { value: string }) {
  return <Mono>{value}</Mono>
}
